<template>
  <list ref="list" :state="9" :result="1">
    <el-dropdown slot="column" slot-scope="{ data }">
      <el-link type="primary">{{ data.ResultText }}<i class="el-icon-arrow-down" /></el-link>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-action="'/api/ProjectManage/Inquiry/SetFeedback'" :disabled="data.Director.Id != operator.Id && data.Executor.Id != operator.Id" @click.native="onFeedback(data)">记录工作反馈</el-dropdown-item>
        <el-dropdown-item v-action="'/api/ProjectManage/Inquiry/SetOutbounds'" :disabled="data.Director.Id != operator.Id && data.Executor.Id != operator.Id" @click.native="setOutbounds(data)">关联出库单号</el-dropdown-item>
        <el-dropdown-item :disabled="data.Director.Id != operator.Id && data.Executor.Id != operator.Id && data.Bidder.Id != operator.Id" @click.native="setFiles(data)">文件管理</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </list>
</template>

<script>
import uploader from '@/views/system/file/multipleUpload.vue'
export default {
  components: { list: () => import("./_list.vue") },
  data () {
    return {
      operator: JSON.parse(localStorage.getItem("user"))
    }
  },
  methods: {
    //客户反馈
    onFeedback (row) {
      this.$prompt(null, '工作记录/反馈', {
        inputType: 'textarea',
        center: true
      }).then(({ value }) => {
        this.$apis.project.inquiry.feedback({ id: row.Id, remarks: value }).then(() => {
          this.$message({ message: "提交成功！", type: "success" })
          this.$refs.list.loadData()
        }).catch((e) => {
          this.$message.error(e)
        })
      })
    },
    setOutbounds (row) {
      this.$prompt("多个请用“,”号分隔开", '填写出库单号', {
        inputType: 'textarea',
        inputValue: row.OutboundArray,
        center: true
      }).then(({ value }) => {
        this.$apis.project.inquiry.outbounds({ id: row.Id, value: value }).then(() => {
          this.$message({ message: "提交成功！", type: "success" })
          this.$refs.list.loadData()
        }).catch((e) => {
          this.$message.error(e)
        })
      })
    },
    setFiles (row) {
      this.$layer.iframe({
        title: '文件管理',
        area: ['500px', '400px'],
        content: {
          content: uploader,
          parent: this,
          data: {
            objectId: row.Id,
            autoupload: true,
            listtype: "text",
            accept: ".xls,.xlsx,.doc,.docx,.rar,.zip"
          }
        }
      })
    }
  }
}
</script>
